import { render, staticRenderFns } from "./ClaimTimeline.vue?vue&type=template&id=89174aba&scoped=true&lang=pug&"
import script from "./ClaimTimeline.vue?vue&type=script&lang=js&"
export * from "./ClaimTimeline.vue?vue&type=script&lang=js&"
import style0 from "./ClaimTimeline.vue?vue&type=style&index=0&id=89174aba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89174aba",
  null
  
)

export default component.exports